import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('lang', lng);
    };

    const flagStyle = {
        width: '26px',
        height: '26px',
        borderRadius: '50%',
        objectFit: 'cover'
    };

    return (
        <div style={{ right: 10, display: 'flex', gap: '5px' }}>
            <button onClick={() => changeLanguage('en')} style={{ padding: 0, border: 'none', background: 'none' }}>
                <img src="/flag-en.png" alt="English" style={flagStyle} />
            </button>
            <button onClick={() => changeLanguage('bg')} style={{ padding: 0, border: 'none', background: 'none' }}>
                <img src="/flag-bg.png" alt="Bulgarian" style={flagStyle} />
            </button>
        </div>
    );
};

export default LanguageSwitcher;
